import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const InputComponent = ({ label, placeholder, value, setValue, required, optional, isInvalid, errorMessage, disabled, type, className="my-2", name }) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);

        // Validate password length if it's a password field
        if (type === 'password' && name === 'new password') {
            if (newValue.length > 0 && newValue.length < 8) {
                setPasswordError(t('Password must be minimum 8 characters & maximum 20 characters'));
            } else if (newValue.length > 20) {
                setPasswordError(t('Password must be minimum 8 characters & maximum 20 characters'));
            } else {
                setPasswordError('');
            }
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const isPasswordField = type === 'password';
    const inputType = isPasswordField && showPassword ? 'text' : type;
    const hasError = isInvalid || passwordError || !!errorMessage;

    return (
        <Form.Group className={className} controlId={label}>
            {label && (
                <Form.Label>
                    {label}
                    {required && <span style={{ color: 'red' }}> *</span>}
                    {optional && <span className="text-muted ms-1">({t("optional")})</span>}
                </Form.Label>
            )}
            <InputGroup>
                <Form.Control
                    type={inputType}
                    placeholder={placeholder}
                    value={value || ""}
                    onChange={handleChange}
                    min={0}
                    minLength={isPasswordField && name === 'new password' ? 8 : undefined}
                    maxLength={isPasswordField && name === 'new password' ? 20 : undefined}
                    required={required}
                    isInvalid={hasError}
                    style={{ 
                        borderRadius: isPasswordField ? "30px 0 0 30px" : "30px",
                        paddingRight: isPasswordField ? "10px" : "12px"
                    }}
                    disabled={disabled}
                />
                {isPasswordField && (
                    <InputGroup.Text
                        onClick={togglePasswordVisibility}
                        style={{
                            cursor: 'pointer',
                            borderRadius: "0 30px 30px 0",
                            backgroundColor: 'white',
                            border: `1px solid ${hasError ? '#dc3545' : '#ced4da'}`,
                            borderLeft: 'none'
                        }}
                    >
                        {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                    </InputGroup.Text>
                )}
            </InputGroup>
            {passwordError && (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                    {passwordError}
                </div>
            )}
            {(errorMessage || isInvalid) && !passwordError && (
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {/* Server-supplied reason when we have one, generic text otherwise. */}
                    {errorMessage || t("This field is required.")}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
}

export default InputComponent;